import React, { Component } from 'react';
import { connect } from 'react-redux';
import { eventShow, eventsShow } from '~/store/actions/event';
import { setAutoSwitch } from '~/store/actions/round';
import oget from 'oget';
import pick from 'lodash.pick';
import first from 'lodash.first';

import Popup from './base/Popup';
import Group from './base/Group';
import Frame from './base/Frame';
import Draggable from './base/Draggable';
import Content from './base/Content';
import Loader from './base/Loader';
import ApiError from './base/ApiError';

import HeaderEvent from './header/HeaderEvent';
import HeaderCard from './header/HeaderCard';
import HeaderScores from './header/HeaderScores';

import ListSwitcher from './table/ListSwitcher';
import TableStartList from './table/TableStartList';
import TableLeaderboard from './table/TableLeaderboard';
import Duel from './duel';
import Updater from './updater';

import breakpoints from '~/breakpoints.scss';
import './index.scss';
import getHeatAthletesCount from '../../utils/getHeatAthletesCount';
import isBrowser from '../../utils/isBrowser';

const { bpTablet, bpPhone, bpPhoneLandscape, bpNoResize } = breakpoints || {};

if (!breakpoints) {
  console.error('Breakpoints where not loaded. Probably due to webpack config for dev environment.');
}

const sizes = {
  desktop: {
    maxHeight: 158,
    maxWidth: 400,
    deviceType: 'desktop',
    minHeight: 158,
    minLeftWidth: 400,
    flexGrow: 100,
    resizable: true,
  },
  tablet: {
    maxHeight: 158,
    maxWidth: 330,
    deviceType: 'tablet',
    minHeight: 158,
    minLeftWidth: 330,
    flexGrow: 100,
    resizable: true,
  },
  phone: {
    maxHeight: '100%',
    maxWidth: '100%',
    deviceType: 'phone',
    minHeight: 0,
    minLeftWidth: 0,
    flexGrow: 0,
    resizable: false,
  },
};

let calculateSize = () => sizes.desktop;

if (isBrowser) {
  calculateSize = () => {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    const orientation = parseInt(window.orientation || 0, 10);

    let size = { ...sizes.desktop };

    if (viewWidth <= parseInt(bpTablet, 10)) {
      size = { ...sizes.tablet };
    }

    if (orientation === 0 || orientation === 180) {
      if (viewWidth <= parseInt(bpPhone, 10)) {
        size = { ...sizes.phone };
      }
    } else {
      if (viewHeight <= parseInt(bpPhoneLandscape, 10)) {
        size = { ...sizes.phone };
      }
    }

    if (viewWidth <= parseInt(bpNoResize, 10)) {
      size.resizable = false;
    }

    return size;
  };
}

const { maxHeight, maxWidth, deviceType, minHeight, minLeftWidth, flexGrow, resizable } = calculateSize();

export default
@connect(
  ({
    apiError,
    apiTimeUpdated,
    event,
    contests,
    contestsById,
    round,
    roundSelection,
    athletes,
    heats,
    heatsById,
    heatId,
    isLive,
    colors,
    countdown,
  }) => ({
    apiError,
    apiTimeUpdated,
    event,
    contests,
    contestsById,
    round,
    roundSelection,
    athletes,
    heats,
    heatsById,
    heatId,
    isLive,
    colors,
    countdown,
  }),
  (dispatch) => {
    const update = Updater(dispatch);
    return {
      onUpdate: (...args) => {
        return update(...args);
      },
      dispatch,
    };
  },
)
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight,
      maxWidth,
      deviceType,
      minHeight,
      minLeftWidth,
      flexGrow,
      resizable,
      eventNotFound: false,
      active: 'start-list',
      fullscreenMode:
        this.props.match.params.hasOwnProperty('viewMode') && this.props.match.params.viewMode === 'fullscreen',
      fullscreenModeForiFrame:
        this.props.match.params.hasOwnProperty('viewMode') && this.props.match.params.viewMode === 'fullscreen',
    };
    this.toggleFullscreenMode = this.toggleFullscreenMode.bind(this);
  }

  onDrag = ({ x, y }) => {
    const { resizable, minHeight, minLeftWidth } = this.state;

    if (!resizable) {
      return;
    }

    y = minHeight;

    if (x < minLeftWidth) {
      x = minLeftWidth;
    }

    if (x >= window.innerWidth / 2) {
      x = window.innerWidth / 2;
    }

    this.setState({
      maxHeight: y,
      maxWidth: x,
    });
  };

  onResize = () => this.setState(calculateSize());

  onOrientationChange = () => setTimeout(this.onResize, 100);

  preloaded = false;

  onPreload = async () => {
    let {
      match: {
        params: { eventId },
      },
      roundSelection: { autoSwitch },
      dispatch,
    } = this.props;

    const { onUpdate } = this.props;

    if (this.preloaded) {
      return;
    }

    let error = null;

    try {
      const eventAction = eventId ? eventShow({ eventId }) : eventsShow();

      if (!eventId) {
        const events = await eventAction.payload;

        eventId = oget(first(events), 'id');
      } else {
        const event = await eventAction.payload;
        eventId = event[0].eventId;
      }
      this.setState({ eventNotFound: false });
      dispatch(eventAction);
    } catch (err) {
      error = err;
      if (err.response.status === 404 || error.response.status === '404') {
        this.setState({ eventNotFound: true });
      }
    }

    onUpdate({
      error,
      eventId,
      autoSwitch,
    });

    this.preloaded = true;
  };

  toggleFullscreenMode() {
    this.setState({
      fullscreenMode: !this.state.fullscreenMode,
    });
  }

  handleToggleAutoSwitch() {
    this.props.dispatch(setAutoSwitch(!this.props.roundSelection.autoSwitch));
  }

  onUpdate = () => {
    const {
      event = {},
      round = { round: {} },
      heatId,
      onUpdate,
      roundSelection: { autoSwitch },
    } = this.props;

    const eventId = oget(event, 'id');

    if (!eventId) {
      return;
    }

    onUpdate({
      eventId,
      selectedContestId: oget(round.round, 'externalContestId'),
      selectedRoundId: oget(round.round, 'externalId'),
      selectedHeatId: heatId,
      autoSwitch,
    });
  };

  loaded = false;

  componentDidUpdate() {
    if (!this.loaded) {
      this.onResize();
      this.loaded = true;
    }
  }

  preloadCalled = false;

  componentDidMount = () => {
    window.addEventListener('resize', this.onResize, false);
    window.addEventListener('orientationchange', this.onOrientationChange, false);

    this.updateInterval = setInterval(() => {
      if (!this.preloadCalled && !this.preloaded) {
        this.preloadCalled = true;
        return this.onPreload();
      }

      this.onUpdate(this.props.roundSelection.autoSwitch);
    }, process.env.REACT_APP_UPDATE_INTERVAL_SECONDS * 1000);
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onOrientationChange);

    clearInterval(this.updateInterval);
  }

  shouldComponentUpdate() {
    return true;
  }

  // eslint-disable-next-line max-lines-per-function
  render() {
    const {
      maxHeight,
      maxWidth,
      flexGrow,
      active,
      deviceType,
      fullscreenMode,
      fullscreenModeForiFrame,
      eventNotFound,
    } = this.state;

    const {
      apiError,
      apiTimeUpdated,
      event,
      contests,
      contestsById,
      round: { round, categories },
      roundSelection,
      athletes,
      heats,
      heatsById,
      heatId,
      isLive,
      colors,
      countdown,
    } = this.props;

    const roundActive = round && round.state && round.state.toLowerCase() === 'active';
    const contest = contests.find((contest) => {
      return contest.externalId === oget(round, 'externalContestId');
    });
    const heatAthletesCount = getHeatAthletesCount(heatsById[heatId]);

    return (
      <div className="view-home" style={colors.home}>
        <Popup />

        <Loader hide={roundSelection.finished} />

        {!eventNotFound && apiError && <ApiError style={colors.apiError}>{apiError}</ApiError>}

        {eventNotFound && (
          <ApiError style={{ backgroundColor: '#FF1717', color: '#FFF' }}>For this ID, no event data exists</ApiError>
        )}

        <HeaderEvent
          event={event}
          contests={contests}
          contestsById={contestsById}
          round={round}
          categories={categories}
          apiTimeUpdated={apiTimeUpdated}
          colors={colors.headerEvent}
          onToggleAutoSwitch={() => this.handleToggleAutoSwitch()}
        />

        {!fullscreenMode && (
          <Group className="group-top" style={{ maxHeight, flexGrow }}>
            <Frame style={{ maxWidth, flexGrow }}>
              <Content
                className="header-user"
                borders={['right-out', 'down']}
                {...pick(colors.headerCard, ['backgroundColor', 'color'])}
              >
                <HeaderCard athletes={athletes} colors={colors.headerCard} eventId={event.eventId} />
              </Content>

              <Draggable style={colors.draggable} grid={[1, 1]} onDrag={this.onDrag} />
            </Frame>

            <Frame>
              <Content
                borders={['left-in', 'down-out']}
                scrollY={true}
                {...pick(colors.headerCard, ['backgroundColor', 'color'])}
              >
                <HeaderScores
                  athletes={athletes}
                  colors={colors}
                  countdown={countdown}
                  round={round}
                  deviceType={deviceType}
                />
              </Content>
            </Frame>
          </Group>
        )}

        <Group className="group-bottom">
          {deviceType === 'phone' && (
            <ListSwitcher
              active={active}
              colors={colors.listSwitcher}
              duelMode={heatAthletesCount === 2}
              onChange={(active) =>
                this.setState({
                  active,
                })
              }
            />
          )}

          {!fullscreenMode && (
            <Frame style={{ maxWidth, flexGrow }}>
              {deviceType !== 'phone' && (
                <Content borders={['up', 'right-out']} {...pick(colors.startList, ['backgroundColor', 'color'])}>
                  <TableStartList
                    event={event}
                    round={round}
                    roundActive={roundActive}
                    heats={heats}
                    heatsById={heatsById}
                    heatId={heatId}
                    athletes={athletes}
                    colors={colors.startList}
                    isLive={isLive}
                  />
                </Content>
              )}

              {deviceType === 'phone' && active === 'start-list' && (
                <Content {...pick(colors.startList, ['backgroundColor', 'color'])}>
                  <TableStartList
                    event={event}
                    round={round}
                    roundActive={roundActive}
                    heats={heats}
                    heatsById={heatsById}
                    heatId={heatId}
                    athletes={athletes}
                    colors={colors.startList}
                    isLive={isLive}
                  />
                </Content>
              )}
            </Frame>
          )}

          <Frame>
            {heatAthletesCount === 2 &&
              (deviceType !== 'phone' || (deviceType === 'phone' && active !== 'start-list')) && (
                <Content
                  borders={!fullscreenMode ? ['up-in', 'left-in'] : []}
                  {...pick(colors.leaderboard, ['backgroundColor', 'color'])}
                >
                  <Duel
                    event={event}
                    contest={contest}
                    round={round}
                    roundActive={roundActive}
                    heats={heats}
                    heatsById={heatsById}
                    heatId={heatId}
                    athletes={athletes}
                    colors={colors.leaderboard}
                    isLive={isLive}
                    deviceType={deviceType}
                    toggleFullscreenMode={this.toggleFullscreenMode}
                    fullscreenMode={fullscreenMode}
                    fullscreenModeForiFrame={fullscreenModeForiFrame}
                  />
                </Content>
              )}

            {heatAthletesCount !== 2 && deviceType !== 'phone' && (
              <Content
                borders={!fullscreenMode ? ['up-in', 'left-in'] : []}
                {...pick(colors.leaderboard, ['backgroundColor', 'color'])}
              >
                <TableLeaderboard
                  event={event}
                  contest={contest}
                  round={round}
                  roundActive={roundActive}
                  heats={heats}
                  heatsById={heatsById}
                  heatId={heatId}
                  athletes={athletes}
                  colors={colors.leaderboard}
                  isLive={isLive}
                  deviceType={deviceType}
                  toggleFullscreenMode={this.toggleFullscreenMode}
                  fullscreenMode={fullscreenMode}
                  fullscreenModeForiFrame={fullscreenModeForiFrame}
                />
              </Content>
            )}

            {heatAthletesCount !== 2 && deviceType === 'phone' && active !== 'start-list' && (
              <Content {...pick(colors.leaderboard, ['backgroundColor', 'color'])}>
                <TableLeaderboard
                  event={event}
                  round={round}
                  roundState={roundActive}
                  heats={heats}
                  heatsById={heatsById}
                  heatId={heatId}
                  athletes={athletes}
                  colors={colors.leaderboard}
                  isLive={isLive}
                  deviceType={deviceType}
                  toggleFullscreenMode={this.toggleFullscreenMode}
                  fullscreenMode={fullscreenMode}
                />
              </Content>
            )}
          </Frame>
        </Group>
      </div>
    );
  }
}
